import { useServiceError } from '@/hooks';
import { queryClient } from '@/Root';
import { notification } from 'antd';
import { useMutation, useQuery } from 'react-query';
import {
  createInvoiceTransport,
  getInvoiceTransport,
  updateInvoiceTransport,
} from './invoiceCarrier.service';
import { InvoiceTransportRequest } from './invoiceCarrier.types';

export function useInvoiceTransport(id: number) {
  const query = useQuery(['transport'], () => getInvoiceTransport(id));

  useServiceError(query.error);

  return query;
}

export function useInvoiceTransportMutation() {
  const mutation = useMutation((id: number) => getInvoiceTransport(id));

  return mutation;
}

export function useCreateInvoiceTransport() {
  const mutation = useMutation(
    (data: { invoiceId: number; obj: InvoiceTransportRequest }) =>
      createInvoiceTransport(data.invoiceId, data.obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'O transporte foi criado.',
        });

        queryClient.invalidateQueries(['transport']);
      },
    },
  );
  useServiceError(mutation.error);
  return mutation;
}

export function useUpdateInvoiceTransport() {
  const mutation = useMutation(
    (data: { invoiceId: number; obj: InvoiceTransportRequest }) =>
      updateInvoiceTransport(data.invoiceId, data.obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'O transporte foi atualizado.',
        });

        queryClient.invalidateQueries(['transport']);
      },
    },
  );
  useServiceError(mutation.error);
  return mutation;
}
